import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
interface FeatureRowProps {
  eyebrow: string;
  title: string;
  body: string;
  bullets?: string[];
  visual: React.ReactNode;
  flip?: boolean;
}
export const FeatureRow = ({
  eyebrow,
  title,
  body,
  bullets,
  visual,
  flip = false
}: FeatureRowProps) => {
  return <div className="py-12 lg:py-16" data-id="element-971">
      <div className={`flex flex-col gap-12 items-center ${flip ? 'lg:flex-row-reverse' : 'lg:flex-row'}`} data-id="element-972">
        <Reveal className="w-full lg:w-1/2" data-id="element-973">
          <p className="text-xs font-semibold uppercase tracking-wider text-zano-pink mb-3" data-id="element-974">
            {eyebrow}
          </p>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-975">
            {title}
          </h3>
          <p className="text-lg text-gray-600 mb-6" data-id="element-976">{body}</p>
          {bullets && <ul className="space-y-3" data-id="element-977">
              {bullets.map((b, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-978">
                  <CheckCircle2 size={18} className="text-zano-pink mt-0.5 shrink-0" data-id="element-979" />{' '}
                  {b}
                </li>)}
            </ul>}
        </Reveal>
        <Reveal delay={0.1} className="w-full lg:w-1/2" data-id="element-980">
          <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-inner" data-id="element-981">
            {visual}
          </div>
        </Reveal>
      </div>
    </div>;
};